import { render, staticRenderFns } from "./sign_up_row.vue?vue&type=template&id=5bbc81af&scoped=true&"
import script from "./sign_up_row.vue?vue&type=script&lang=js&"
export * from "./sign_up_row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbc81af",
  null
  
)

export default component.exports